import React, { useState, useEffect } from 'react';

// Material UI:
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// Components:
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const SectionFilterComponent = ({ handleSubmit, onSubmit, register, errors }) => {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        container
        spacing={1}
        alignItems='center'
        sx={{
          width: 'calc(100vw - 270px)',
        }}
      >
        <Grid item size={{ xs: 12, md: 2 }}>
          <TextField
            required
            fullWidth
            label='*Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid item size={{ xs: 12, md: 2 }}>
          <TextField
            required
            fullWidth
            label='*Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid item size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            label='Número de teléfono'
            {...register('direct_number')}
            error={Boolean(errors.phone_number)}
            helperText={errors.phone_number?.message}
          />
        </Grid>

        <Grid item size={{ xs: 12, md: 2 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default SectionFilterComponent;
